// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"c7bb90cf","453":"35bd3340"}[chunkId] + ".chunk.js";
};